module.exports = __webpack_public_path__ + "static/Caley-main-desktop-822e52ebf94ca5ba07a257d09240a6e2.png";